export default class LoggerService {

    public static async simpleLog(category: string, ...payload: any[]) {
        this.log({
            category,
        }, ...payload);
    }

    public static async simpleError(category: string, ...payload: any[]) {
        this.log({
            category,
        }, ...payload);
    }

    public static async log(options: {
        category?: string,
        level?: 'debug' | 'warn' | 'info' | 'error' | 'log'
    }, ...payload) {

        const { 
            level = 'log',
        } = options;

        const logItems: any[] = [];
        if (options.category) {
            logItems.push(`[${options.category}]`);
        }
        
        logItems.push(...payload);

        if (level === 'log') {
            console.log(...logItems);
        }
        else if (level === 'error') {
            console.error(...logItems);
        }
        else if (level === 'warn') {
            console.warn(...logItems);
        }
    }
}